import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id", "title"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-6 ms-1" }, "close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "selected-category btn btn-sm btn-green d-flex justify-content-between align-items-center fs-7 lh-sm text-white text-wrap fw-bold m-1 pe-1",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "top",
    "data-bs-html": "true",
    ref: this.refTooltip,
    id: this.refTooltip,
    title: this.tooltipContent,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (this.removeCategory(this.selectedProductCategoryCode)), ["prevent"]))
  }, [
    (_ctx.categoryInfo)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.categoryInfo.current_category.description.toUpperCase()), 1))
      : _createCommentVNode("", true),
    _hoisted_3
  ], 8, _hoisted_1))
}